import { SVGProps } from "react";

const CheckmarkIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <g clipPath="url(#a)">
        <circle cx="12" cy="12" r="12" fill="#03824F" />
        <path
          stroke="#fff"
          strokeLinecap="square"
          strokeWidth="1.2"
          d="M7 12.77 10.438 16 17 9"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckmarkIcon;
